import { makeKey, update } from "../../../../utils/reducerOperations";
export function responsesStarted(state, payload) {
  return makeKey(
    "responsesApi",
    update(state.responsesApi, { isProcessing: true })
  );
}
